import { HTTPClient } from "../utils/request";

export default {
  check: ({ query }) => HTTPClient.get(`/is_exist?cpf=${query}`)
};
